module.exports = __webpack_public_path__ + "media/images/icons/flags/SM-268e15dcca7139cb749df64682e34c6d.svg";